import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
const Menu = ({ route }) => {
  return (
    <SMenu>
      <MenuButton>{route.name}</MenuButton>
      <SubRoutesContainer>
        {route.subRoutes.map((subRoute) => (
          <SubRoute to={subRoute.link} key={subRoute.name}>
            {subRoute.name}
          </SubRoute>
        ))}
      </SubRoutesContainer>
    </SMenu>
  );
};

export default Menu;

const SubRoutesContainer = styled.div`
  position: absolute;
  min-width: 32rem;
  display: flex;
  flex-direction: column;
  left: -1rem;
  visibility: hidden;
  opacity: 0;
    
  &:hover {
    width: 100%;
    transition: all 0.3s ease-in;
    color: var(--brown)
    background-color: var(--white);
  } 
`;

const SMenu = styled.div`
  position: relative;
  display: inline-block;

  &:hover ${SubRoutesContainer} {
    visibility: visible;
    opacity: 1;
    color: var(--brown)
    background-color: var(--white);
    cursor: pointer;
  }
`;

// DROPDOWN NAVBAR WITHOUT MEDIA QUERY
const MenuButton = styled.div`
  padding: 0.5rem;
  font-size: 20px;
 
  &:hover {
    transition: 0.5s ease;
    color: var(--brown);
    background-color: var(--white);
    box-shadow: 0px 0px 10px white;
    border-radius: 5px;
    cursor: pointer;
  }

  @media screen and (max-width: 1200px) {
    font-size: 20px;
     white-space: nowrap;
  }
`;


// SUBMENU DISPLAY WITHOUT MEDIA QUERY
const SubRoute = styled(Link)`
  text-decoration: none;
  background-color: var(--brown);
  color: var(--white);
  padding: 1rem;
  width: 100%;
  margin-top:0;
  font-size: 18px;

    &:hover {
    transition: all 0.2s ease-out;
    color: var(--brown);
    background-color: var(--white);
    box-shadow: 0px 0px 10px white;  
  }
`;
